import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TitleService } from './core/services/title.service';
import {SpinnerComponent} from './shared/spinner/spinner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'app';

  constructor(
    private titleService: TitleService,
  ) {}
}
